import ParentESN from '../ParentESN'

export default {
  objectType : 'globalstar',
  attrName : 'Parent Device ESN',
  renderer : ( { data, row } ) => ParentESN( data.find( i => i.id === row?.id )?.data?.data?.boat?.id )
} 
